"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var qs_1 = __importDefault(require("qs"));
var FilterParser = /** @class */ (function () {
    function FilterParser(filters) {
        this.onSelectMethod = null;
        this.filterParam = "filters";
        this.filters = filters;
        if (filters === null) {
            throw Error("filters cannot be null");
        }
        if (typeof filters !== "object") {
            throw Error("filters must be an object");
        }
    }
    FilterParser.prototype.getFilters = function () {
        return this.filters;
    };
    FilterParser.prototype.getFilter = function (field) {
        if (this.hasFilter(field)) {
            return this.filters[field];
        }
        else {
            return null;
        }
    };
    FilterParser.prototype.parse = function (input) {
        if (typeof input === "string") {
            this.parseFromString(input);
        }
        else {
            this.parseFromObject(input);
        }
    };
    FilterParser.prototype.parseFromString = function (input) {
        var filters = {};
        if (input.startsWith("?")) {
            input = input.substring(1);
        }
        var query = qs_1.default.parse(input);
        if (query) {
            if (query.hasOwnProperty(this.filterParam)) {
                filters = query[this.filterParam];
            }
            this.parseFromObject(filters);
        }
    };
    FilterParser.prototype.parseFromObject = function (filters) {
        if (filters !== null && typeof filters === "object") {
            for (var i in this.filters) {
                if (this.filters.hasOwnProperty(i)) {
                    if (filters.hasOwnProperty(i)) {
                        this.setValue(i, filters[i]);
                    }
                }
            }
        }
    };
    /**
     * Sets the value of a field
     * @param field
     * @param value
     */
    FilterParser.prototype.setValue = function (field, value) {
        if (this.hasFilter(field)) {
            var previous = this.filters[field].hasOwnProperty("selected")
                ? this.filters[field].selected
                : null;
            this.filters[field].selected = value;
            this.changed(field, value, previous);
        }
    };
    /**
     * Check to see if the selected field exists as a filter.
     * @param field
     */
    FilterParser.prototype.hasFilter = function (field) {
        return this.filters.hasOwnProperty(field);
    };
    FilterParser.prototype.exportQuery = function (asArray) {
        if (asArray === void 0) { asArray = true; }
        var output = {};
        for (var i in this.filters) {
            if (this.filters.hasOwnProperty(i)) {
                var filter = this.filters[i];
                var value = "";
                if (filter.hasOwnProperty("filterParamEncode")) {
                    value = filter.filterParamEncode(filter);
                }
                else {
                    value =
                        this.filters[i].hasOwnProperty("selected") &&
                            this.filters[i].selected !== null &&
                            this.filters[i].selected.hasOwnProperty("toString")
                            ? this.filters[i].selected.toString()
                            : this.filters[i].selected;
                }
                output[i] = value;
            }
        }
        if (asArray) {
            return output;
        }
        return qs_1.default.stringify({ filters: output });
    };
    FilterParser.prototype.onSelect = function (onChangeMethod) {
        this.onSelectMethod = onChangeMethod;
    };
    FilterParser.prototype.changed = function (field, value, previousValue) {
        if (this.onSelectMethod !== null) {
            this.onSelectMethod(field, value, previousValue);
        }
    };
    return FilterParser;
}());
exports.default = FilterParser;
//# sourceMappingURL=data:application/json;base64,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